import { type ReactNode } from "react";

import {
  DocumentBundleParticipantActivity,
  DocumentBundleParticipantStatus,
} from "graphql_globals";
import { useRetireSignerIdentities } from "common/signer/identity/retire";
import { SIGNER_IDS_SESSION_KEY } from "common/signer/initiate_signing";

type RenderProps = {
  handleAction: (action: () => void) => void;
};

type Props = {
  viewer: { user: null | { id: string } };
  participants:
    | ({
        id: string;
        userId: string;
        signingActivity: DocumentBundleParticipantActivity;
        signingStatus: DocumentBundleParticipantStatus;
      } | null)[]
    | null;
  children: (renderProps: RenderProps) => ReactNode;
};

const viewerHasActiveSession = ({
  participants,
  viewer,
}: Pick<Props, "participants" | "viewer">) => {
  const userParticipant = participants?.find(
    (participant) => participant?.userId === viewer.user?.id,
  );
  return userParticipant
    ? userParticipant.signingActivity !== DocumentBundleParticipantActivity.NOT_SIGNING &&
        userParticipant.signingStatus !== DocumentBundleParticipantStatus.COMPLETE
    : false;
};

export default function ActiveSessionRestartActionWrapper({
  viewer,
  participants,
  children,
}: Props) {
  const retireSignerIdentities = useRetireSignerIdentities();

  const handleAction = (action: () => void) => {
    const hasActiveSession = viewerHasActiveSession({ participants, viewer });
    if (hasActiveSession) {
      retireSignerIdentities({ ignoreNoActive: true }).then(() => {
        window.sessionStorage.removeItem(SIGNER_IDS_SESSION_KEY);
        action();
      });
    } else {
      action();
    }
  };

  return <>{children({ handleAction })}</>;
}
